import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  FormControl, 
  FormLabel, 
  RadioGroup, 
  FormControlLabel, 
  Radio,
  Paper
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../context/ThemeContext';

const Settings = () => {
  const { t, i18n } = useTranslation();
  const { mode, setThemeMode } = useTheme();

  const handleLanguageChange = (event) => {
    i18n.changeLanguage(event.target.value);
    localStorage.setItem('i18nextLng', event.target.value);
  };

  const handleThemeChange = (event) => {
    setThemeMode(event.target.value);
  };

  return (
    <Container maxWidth="md" sx={{ mt: 12, mb: 4 }}>
      <Typography 
        variant="h4" 
        component="h1" 
        sx={{ 
          mb: 4,
          fontWeight: 300,
          letterSpacing: '0.1em'
        }}
      >
        {t('settings.title')}
      </Typography>

      <Paper 
        elevation={0}
        sx={{ 
          p: 4,
          background: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(10px)',
          borderRadius: 2,
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <Box sx={{ mb: 4 }}>
          <FormControl component="fieldset">
            <FormLabel 
              component="legend"
              sx={{ 
                color: 'primary.main',
                mb: 2,
                '&.Mui-focused': {
                  color: 'primary.main'
                }
              }}
            >
              {t('settings.language')}
            </FormLabel>
            <RadioGroup
              value={i18n.language}
              onChange={handleLanguageChange}
              sx={{
                '& .MuiRadio-root': {
                  color: 'primary.main'
                }
              }}
            >
              <FormControlLabel value="en" control={<Radio />} label={t('settings.language_en')} />
              <FormControlLabel value="es" control={<Radio />} label={t('settings.language_es')} />
            </RadioGroup>
          </FormControl>
        </Box>

        <Box>
          <FormControl component="fieldset">
            <FormLabel 
              component="legend"
              sx={{ 
                color: 'primary.main',
                mb: 2,
                '&.Mui-focused': {
                  color: 'primary.main'
                }
              }}
            >
              {t('settings.theme')}
            </FormLabel>
            <RadioGroup
              value={mode}
              onChange={handleThemeChange}
              sx={{
                '& .MuiRadio-root': {
                  color: 'primary.main'
                }
              }}
            >
              <FormControlLabel value="light" control={<Radio />} label={t('settings.theme_light')} />
              <FormControlLabel value="dark" control={<Radio />} label={t('settings.theme_dark')} />
              <FormControlLabel value="auto" control={<Radio />} label={t('settings.theme_auto')} />
            </RadioGroup>
          </FormControl>
        </Box>
      </Paper>
    </Container>
  );
};

export default Settings;